import { createFileRoute } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { useQuery } from '@apollo/client/react'
import { policiesQuery } from '@/gql/queries'
import he from 'he';

export const Route = createFileRoute('/desktop/__app/how-to-play/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data, loading } = useQuery(policiesQuery)

  if (loading && !data) return null

  const content = data.sortelecExtraceos[0]?.text
  const table = data.sortelecExtraceos[0]?.tableContent
  return (
    <div className={styles.container}>
      <header>
        <h3>Extração</h3>
      </header>
      <div>
        <p dangerouslySetInnerHTML={{ __html: he.decode(content) }} />
      </div>


      <div>
        <b>Premiação</b>

        <div>
          <p
            dangerouslySetInnerHTML={{ __html: table }}
          />
        </div>

      </div>
    </div>
  )
}
